import { render, staticRenderFns } from "./BtnFavorite.vue?vue&type=template&id=bcd9225a&scoped=true&"
import script from "./BtnFavorite.vue?vue&type=script&lang=js&"
export * from "./BtnFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd9225a",
  null
  
)

export default component.exports